import { render, staticRenderFns } from "./EventsSingleMore.vue?vue&type=template&id=845e8298&"
import script from "./EventsSingleMore.vue?vue&type=script&lang=js&"
export * from "./EventsSingleMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports